/**
 * Rules presets (`/admin/presets`, staff only; the route sits under
 * `RequireSuperAdmin`): reads on open (`use-presets.ts`), then the body
 * (`presets-view.tsx`).
 */
import { PlacesError, PlacesLoading } from "@/features/places/places-page";
import { PresetsHeading, PresetsView } from "@/features/presets/presets-view";
import { usePresets } from "@/features/presets/use-presets";

export function PresetsPage() {
  const load = usePresets();
  if (load.state === "ready") return <PresetsView data={load.data} sample={load.sample} />;
  return (
    <div className="flex flex-col gap-5">
      <PresetsHeading sample={false} />
      {load.state === "loading" ? (
        <PlacesLoading what="the rules presets" />
      ) : (
        <PlacesError title="Could not read the rules presets" message={load.message} />
      )}
    </div>
  );
}
